export default "__VITE_ASSET__BF0rFJto__"